import { render, staticRenderFns } from "./PayRuns.vue?vue&type=template&id=dd084180&scoped=true"
import script from "./PayRuns.vue?vue&type=script&lang=js"
export * from "./PayRuns.vue?vue&type=script&lang=js"
import style0 from "./PayRuns.vue?vue&type=style&index=0&id=dd084180&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd084180",
  null
  
)

export default component.exports